/* eslint-disable @typescript-eslint/naming-convention */
export interface CognitoConfig {
  authority: string;
  client_id: string;
  redirect_uri: string;
  response_type: string;
  scope: string;
  cognitoDomain: string;
  logoutUri: string;
}

// Since we are loading from process.env, we just need one config object
// that reads the populated values.
// Rspack/Webpack DefinePlugin will inject the string values here.

export const cognitoAuthConfig: CognitoConfig = {
  // @ts-ignore
  authority: process.env.XEC_COGNITO_AUTHORITY || "",
  // @ts-ignore
  client_id: process.env.XEC_COGNITO_CLIENT_ID || "",
  // @ts-ignore
  redirect_uri: process.env.XEC_COGNITO_REDIRECT_URI || "",
  // @ts-ignore
  response_type: process.env.XEC_COGNITO_RESPONSE_TYPE || "code",
  // @ts-ignore
  scope: process.env.XEC_COGNITO_SCOPE || "openid",
  // @ts-ignore
  cognitoDomain: process.env.XEC_COGNITO_DOMAIN || "",
  // @ts-ignore
  logoutUri: process.env.XEC_COGNITO_LOGOUT_URI || "",
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const signOutRedirect = () => {
  const { client_id, logoutUri, cognitoDomain } = cognitoAuthConfig;
  window.location.href = `${cognitoDomain}/logout?client_id=${client_id}&logout_uri=${encodeURIComponent(logoutUri)}`;
};
